import * as React from 'react';

export default ({ color }) => (
  <svg width="26" height="22" viewBox="-3 0 26 22">
    <g
      transform="translate(1 1)"
      stroke={color || '#979797'}
      strokeWidth="2"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M11 3 3.5 6.5H1a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h2.5L11 17z" />
      <path d="M15 6.5a6 6 0 0 1 0 7M3.5 13.5V19" />
    </g>
  </svg>
);
